import { Base64 } from 'js-base64';
import { getDataType, setEnvPrefix } from './commonUtils';

export function parseToken(t) {
    let parts = t.split('.');
    parts[1] = JSON.parse(Base64.decode(parts[1]));
    return {...parts[1],
        token: t,
        jti: parseInt(parts[1].jti),
        userFingerprint: parts[1].userFingerprint,
        jwtSession: {...parts[1].jwtSession,
            USER_ID: parseInt(parts[1].jwtSession.USER_ID)
        }
    }
};

export function htmlStorage(type) {
    let storageType;

    switch (type) {
        case 'local': storageType = 'localStorage'; break;
        case 'session': storageType = 'sessionStorage'; break;
        default: storageType = 'sessionStorage';
    }

    return {
        clrAll: redirect => {
            window.session = null;
            sessionStorage.clear();
            localStorage.clear();

            if (redirect != null)
                if (window.session == null && localStorage.getItem('ssSession') == null && sessionStorage.getItem('ssSession') == null)
                    window.location.href = redirect;
        },
        clr: redirect => {
            window.session = null;
            window[storageType].clear();
            if (redirect != null)
                if (window.session == null && localStorage.getItem('ssSession') == null && sessionStorage.getItem('ssSession') == null)
                    window.location.href = redirect;
        },
        set: a => {
            switch (getDataType(a)) {
                case 'Object':
                    for (let p in a) {
                        if (getDataType(a[p]) === 'Object')
                            a[p] = JSON.stringify(a[p]);
                        }
                    for (let p in a)
                        window[storageType].setItem(p, a[p]);
                    break;
            }
        },
        get: (k, autoClear) => {
            if (window[storageType].length === 0) return null;

            autoClear = !!autoClear;
            let result = {}, d;

            switch (getDataType(k)) {
                case 'String':
                    d = JSON.parse(window[storageType].getItem(k));
                    for (let p in d) switch (p) {
                        case 'token': d = parseToken(d[p]); break;
                    }

                    break;
                case 'Array':
                    d = {};
                    k.forEach(key => d[key] = JSON.parse(window[storageType].getItem(key)));
                    for (let p in d) switch (p) {
                        case 'ssSession':
                            for (let a in d[p]) switch (a) {
                                case 'token': d[p] = parseToken(d[p][a]); break;
                            }
                            break;
                    }
                    break;
            }

            // Automatically clear the data from storage.
            if (autoClear) window[storageType].clear();

            return d;
        },
        which: (k, returnDataFromStorage) => {
            returnDataFromStorage = !!returnDataFromStorage;
            let storages = [ 'localStorage', 'sessionStorage' ];

            for (let i in storages) {
                let storage = storages[i];
                if (window[storage].length > 0)
                    for (let e in window[storage])
                        if (e === k)
                            return returnDataFromStorage
                                ? JSON.parse(window[storage].getItem(k))
                                : storage;
            }

            return `[htmlStorage] "${ k }" not found.`;
        }
    };
}

export function logout() {

    let path = '/home';
    if (session && session.jwtSession && session.jwtSession.ROLES[0]) {
        switch ( session.jwtSession.ROLES[0] ) {
            case 'ADMIN':
            case 'ASI':
                path = '/analyst';
                break;
            case 'DOD':
                path = '/home/dod';
                break;
            case 'FSDO':
                path = '/home/fsdo';
                break;
            case 'PROVIDER_AGENT':
            case 'PROVIDER_ADMIN':
                path = '/home/provider';
                break;
        }

    }
    let http = new XMLHttpRequest();

    http.open('POST', setEnvPrefix('/session/logout'));
    http.setRequestHeader('Authorization', `Bearer ${session.token}`);
    http.send();

    http.onreadystatechange = function() {
        if (http.readyState == 4) {
            htmlStorage().clrAll(setEnvPrefix(path));
        }
    }
}

/** * [TO - DO] * Needs to be redesigned.It does not work well with the new structure. * Going forward,
I would like this to aware of the global "window.session" * and, could, also be aware of the html storage stored token. */

// READ. THE. CODE. It is aware of the window.session AND the stored token. Follow the 'clrAll' function.
// I designed it, I made sure it cleared the window.session AND the stored token. It does NOT just redirect.
// Once more, READ. THE. CODE.
// - Jonathon Tech

export function sessionTimer() {
    return {
        run: function(time) {
            var minutes = time * 1000;
            time = time || 20;
            setInterval(function() {
                idler++;
                if(idler === time) endSession();
                else if(idler === (time - 1)) endSessionNotice();
            }, 60000);
        },
        restart: function() {
            updateSessionExpiration();
            idler = 0;
        }
    }
}

export function hasPermission(perm, population) {
    const { permissions } = window.session.jwtSession;

    for(let p in permissions)
        if(permissions[p].authority === perm && (population == undefined || population == null || permissions[p].population === population))
            return true;

    return false;
}

export const SESSION_HOME = (() => {
    const loc = htmlStorage().get('home');
    if (loc && loc.hasOwnProperty('path')) return loc.path;
    else return setEnvPrefix('/home');
})();

export function isSessionHome(redirect=true) {
    let loc = htmlStorage().get('home');

    if (loc && loc.hasOwnProperty('path')) loc = loc.path;
    else loc = setEnvPrefix('/home');

    if (loc !== setEnvPrefix('/home') && loc !== window.location.pathname) {
        if (redirect) window.location.href = loc;
        return false;
    }

    return true;
}

export function redirectToHome() {
    const
    validHomes = [
        '/home',
        '/home/provider',
        '/home/candidate',
        '/home/analyst',
        '/home/fsdo',
        '/home/dod'
    ],
    { pathname } = window.location,
    home = htmlStorage().get('home');

    if (home == null) htmlStorage().set({ home: { path: pathname }});
    else {
        const { path } = home;
        if (validHomes.find(h => h === pathname) != null && path !== pathname)
            window.location.href = path;
    }
}

export function isDod() {
    return isRole('DOD');
}

export function checkRole(roleList){
  var found = false;
  if(window.session.jwtSession.ROLES){
    window.session.jwtSession.ROLES.forEach(rVal=>{
      roleList.forEach(role=>{
      if(rVal==role){
        found = true;
      }
      });
    })
  }

  if(!found){
    htmlStorage().clrAll();
    window.session = null;
    window.location.href = setEnvPrefix('/home');
  }
}

function isRole(role){
  if(window.session.jwtSession.ROLES){
    if (window.session.jwtSession.ROLES.indexOf(role)!= -1)
        return true;
  }
  return false;
}